<div class="bg-white mb-10 rounded-2xl border border-[#e4e7ec]">
  <div class="overflow-x-auto no-scrollbar relative print-section flex flex-col overflow-y-auto bg-white rounded-2xl max-h-[calc(100%-200px)]">
    <!-- Main container -->
    <ng-template #contentTemplate>
      <ng-content></ng-content>
    </ng-template>

    <!-- Check if ng-content has anything -->
    <div *ngIf="contentTemplate.createEmbeddedView(null).rootNodes.length > 0" class="py-4 w-full flex flex-wrap px-6 justify-between items-center">
      <ng-container [ngTemplateOutlet]="contentTemplate"></ng-container>
    </div>
    <div *ngIf="contentTemplate.createEmbeddedView(null).rootNodes.length == 0" class="w-full flex px-6 justify-between items-center">
      <!-- No height if no content -->
    </div>
    <div class="overflow-y-auto no-scrollbar h-full">
      <table class="table-auto text-text-color-600 w-full border-t border-b border-t-[#e4e7ec]  ">
        <thead class="sticky top-[0px] z-10 bg-white text-sm font-medium text-primary capitalize tracking-wider">
          <tr>
            <th *ngFor="let column of columns;let i = index" [ngClass]="{'flex justify-center items-center': column.title == 'Status','sticky right-0 left-0 bg-white mt-[1px]' : column.sticky == true}" class="px-4 h-12 text-center truncate">
              <div *ngIf="column.title != 'Action'" [class]="column?.class">
                <ng-container *ngIf="column.key == 'index'; else showTitle">
                  <!-- <img src="../../../assets/container.svg" alt="Caret Up" /> -->
                  <input type="checkbox" class="cursor-pointer" (change)="toggleAllSelection()" [checked]="allSelected">
                </ng-container>
                <ng-template #showTitle>
                  <div [ngClass]="{'justify-center': column.title == 'Status'}" class="flex gap-2 items-center justify-between w-full text-base font-medium">
                    {{ column.title }}
                    <!-- <img src="../../../assets/Frame 1410266058.png" alt="Icon" class="inline-block cursor-pointer" (click)="toggleDropdown(i)" /> -->
                    <app-mini-modal  *ngIf="column?.filter" image_class="inline-block min-w-6 min-h-6 cursor-pointer" image="../../../assets/Frame 1410266058.png" >   
                      <!-- Dropdown -->
                      <div class="w-auto px-6 bg-[#F9F9FA] rounded-lg border p-4 pt-4 pb-4 pr-6 pl-6 gap-2">
                        <span *ngIf="column?.sort" class="text-primary text-sm font-medium">Sort</span>
                        <div class="text-[#1E1E1E] capitalize font-medium text-sm flex flex-col gap-2">
                          <ng-container *ngIf="column?.sort">
                            <div class="w-[180px] cursor-pointer h-8 gap-2 flex items-center justify-start" (click)="sortData(column.key, 'asc')">
                              <img src="../../../assets/ascending_icon.svg" alt=""><span>Ascending</span>
                            </div>
                            <div class="flex justify-start cursor-pointer items-center gap-2"  (click)="sortData(column.key, 'desc')">
                              <img src="../../../assets/descending_icon.svg" alt=""><span>Descending</span>
                            </div>
                          </ng-container>
                          <div *ngIf="column?.filter_options" class="w-[180px] rounded-full h-[1px] bg-[#1E1E1E1F]"></div>
                          <span *ngIf="column?.filter_options" class="text-primary text-sm font-medium">Filter</span>
                          <div>
                            <ul class="text-gray-700">
                              <li *ngFor="let filter of column.filter_options" class="cursor-pointer py-2 flex items-center" (click)="filter.checked = !filter.checked ;updateFilters(column)">
                                <input type="checkbox" class="mr-2" [checked]="filter.checked" (click)="$event.stopPropagation()"/>
                                {{ filter.name }}
                              </li>
                            </ul>
                          </div>
                          <div *ngIf="column.filter == 'Date' || column.filter == 'date'">
                          <p class="text-primary text-sm font-medium mb-2">Select {{column.title}}</p>
                             <app-date-range-picker [(ngModel)]="date"  (ngModelChange)="onDateRangeChange($event, column.title)" label="Start Date" ></app-date-range-picker>
                          </div>
                        </div>
                      </div>
                    </app-mini-modal>
                  </div>
                </ng-template>
              </div>
            </th>
          </tr>
        </thead>
        <tbody class="text-sm font-normal text-[#1E1E1E] tracking-[0.32px] ">
            <!-- Main Row -->
           <app-table-row #table_row [items]="items" [columns]="columns" (selectedIdsChange)="get_seleted_ids($event)" ></app-table-row>

            <!-- Child Rows -->
            
    <!-- <tr *ngFor="let child of item.children" [ngClass]="{ 'hidden': !item.expanded }" class="border-b border-[#e4e7ec] bg-white border-t-[#e4e7ec] border-l-2 text-[#666666] border-r-transparent border-l-[#DEB900]">
              <ng-container *ngFor="let column of columns">
                <td *ngIf="column.forChild" class="px-4 h-16 text-sm">
                  <ng-container *ngIf="column.key == 'status'; else normalChildCell">
                    <div class="flex justify-center items-center">
                      <button class="px-2 py-1 rounded-full border-none text-sm font-medium flex justify-center items-center" [ngClass]="{
                    'text-[#03A600]': child.status == 'Approved',
                    'text-[#DF6E12]': child.status == 'Pending',
                    'text-red-500 ': child.status == 'Rejected'
                  }">
                        <div class="h-2 w-2 rounded-full mr-[6px]" [ngClass]="{
                   'bg-[#03A600]': child.status == 'Approved',
                   'bg-[#DF6E12]': child.status == 'Pending',
                   'bg-red-500 ': child.status == 'Rejected'
                 }"></div>
                        {{ child.status }}
                      </button>
                    </div>
                  </ng-container>
                  <ng-template #normalChildCell>
                    {{ child[column.key] || '-' }}
                  </ng-template>
                </td>
              </ng-container>
            </tr> -->

    </tbody>
    </table>
  </div>

  <div *ngIf="items?.length == 0" class="felx justify-center items-center rounded-b-2xl bg-white border-t border-[#e4e7ec]">
    <div class="w-full h-[65vh] p-10 flex justify-center items-center">
      <div class="flex flex-col items-center gap-2 justify-center">
        <img src="../../../assets/no-records.gif" class="w-[200px] h-[200px] object-contain" alt="No Records" />
        <!-- <span>No Record found</span> -->
        <div class="text-[22px] text-primary text-center">{{label}}</div>
        <div class="text-[#A3A3A3] text-base text-center">{{description}}</div>
      </div>
    </div>
  </div>
</div>
</div>
<div class="fixed bottom-0 py-2 w-[92%] bg-[#f7f7f7] mt-5" *ngIf="pagination">
  <app-pagination [currentPage]="currentPage" [totalPages]="totalPages" [totalItems]="totalItems"
    [itemsPerPage]="itemsPerPage" (onPageChange)="handlePageChange($event)"></app-pagination>
</div>